import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatModule } from 'core/material/mat.module';
import { PipesModule } from 'core/pipes/pipes.module';
import { PriceModule } from 'core/price/price.module';
import { TranslationModule } from 'core/translation/translation.module';
import { NgxPaginationModule } from 'ngx-pagination';

import { TextEditingModule } from '../text/text.module';
import { ColorChooserComponent } from './color-chooser/color-chooser.component';
import { FontChooserComponent } from './font-chooser/font-chooser.component';
import { ImageCropperComponent
       } from './image-cropper/image-cropper.component';
import { ImageQualityRatingComponent
       } from './image-quality-rating/image-quality-rating.component';
import { ImageRotateComponent } from './image-rotate/image-rotate.component';
import { ImageZoomComponent } from './image-zoom/image-zoom.component';
import { PrnglPreviewComponent
       } from './prngl-preview/prngl-preview.component';
import { ProductChooserComponent
       } from './product-chooser/product-chooser.component';
import { ProgressOverlayComponent
       } from './progress-overlay/progress-overlay.component';
import { ProgressSymbolComponent
       } from './progress-overlay/progress-symbol.component';
import { SingleOptionChooserComponent
       } from './single-option-chooser/single-option-chooser.component';
import { TemplateChooserComponent
       } from './template-chooser/template-chooser.component';
import { PlaceholderTextareaComponent
       } from './text-editing/placeholder-textarea.component';
import { TextAlignmentChooserComponent
       } from './text-editing/text-alignment-chooser.component';
import { TextEditingComponent } from './text-editing/text-editing.component';
import { TextEffectsChooserComponent
       } from './text-editing/text-effects-chooser.component';
import { TextSizeChooserComponent
       } from './text-editing/text-size-chooser.component';
import { ToastComponent } from './toast/toast.component';
import { WebGLPreviewComponent
       } from './webgl-preview/webgl-preview.component';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    MatModule,
    PipesModule,
    PriceModule,
    TranslationModule,
    NgxPaginationModule,
    TextEditingModule,
    OverlayModule,
  ],
  declarations: [
    ColorChooserComponent,
    FontChooserComponent,
    ImageCropperComponent,
    ImageQualityRatingComponent,
    ImageZoomComponent,
    ImageRotateComponent,
    ProductChooserComponent,
    ProgressOverlayComponent,
    ProgressSymbolComponent,
    SingleOptionChooserComponent,
    TemplateChooserComponent,
    TextAlignmentChooserComponent,
    TextEffectsChooserComponent,
    TextEditingComponent,
    TextSizeChooserComponent,
    ToastComponent,
    PlaceholderTextareaComponent,
    WebGLPreviewComponent,
    PrnglPreviewComponent,
  ],
  exports: [
    ColorChooserComponent,
    FontChooserComponent,
    ImageCropperComponent,
    ImageQualityRatingComponent,
    ImageZoomComponent,
    ImageRotateComponent,
    ProductChooserComponent,
    ProgressOverlayComponent,
    ProgressSymbolComponent,
    SingleOptionChooserComponent,
    TemplateChooserComponent,
    TextAlignmentChooserComponent,
    TextEffectsChooserComponent,
    TextEditingComponent,
    TextSizeChooserComponent,
    ToastComponent,
    PlaceholderTextareaComponent,
    WebGLPreviewComponent,
    PrnglPreviewComponent,
  ],
})
export class ControlsModule { }
